const ServiceNetwork = () => {
  return (
    <div className="relative mt-20 sm:mt-32 px-3 sm:grid sm:grid-cols-2 sm:gap-10">
      <div>
        <div className="hidden sm:flex sm:flex-col sm:space-y-3 lg:hidden">
          <h1 className="text-3xl sm:text-4xl font-bold pt-3 font-mono">
            What you need, when you need it
          </h1>
          <p className="text-lg font-semibold">
            Spend less time shuffling tabs with a comprehensive message archive
            and all your work tools at your fingertips.
          </p>
        </div>
        <div className="py-3 sm:hidden lg:inline-grid">
          <img src="/images/Network.svg" alt="" />
        </div>
      </div>
      <div>
        <div className="flex flex-col space-y-3 sm:hidden lg:block">
          <h1 className="text-2xl lg:text-4xl font-bold pt-3 font-mono">
            What you need, when you need it
          </h1>
          <p className="text-lg font-semibold">
            Spend less time shuffling tabs with a comprehensive message archive
            and all your work tools at your fingertips.
          </p>
        </div>
        <div className="py-3 hidden sm:block lg:hidden">
          <img src="/images/Network.svg" alt="" />
        </div>
      </div>
    </div>
  );
};

export default ServiceNetwork;
